import firebase from '../api/firebase';
const ReduxSagaFirebase = require('redux-saga-firebase').default;

export default new ReduxSagaFirebase(firebase);
